"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberInput = _interopRequireDefault(require("./NumberInput"));

var SsnInput = function SsnInput(_ref) {
  var isLastFour = _ref.isLastFour,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["isLastFour"]);
  return /*#__PURE__*/_react.default.createElement(_NumberInput.default, (0, _extends2.default)({}, otherProps, {
    format: isLastFour ? '####' : '###-##-####',
    isNumericString: true
  }));
};

SsnInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Social security number value that controls the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** Changes format for when only the last four are provided */
  isLastFour: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
SsnInput.defaultProps = {
  errorText: '',
  isLastFour: false,
  value: null,
  fsMask: true
};
var _default = SsnInput;
exports.default = _default;